import { Language } from "./language";

export class Translation {
  DeleteDate: string;
  Id: number;
  IdGuid: string;
  InsertDate: string;
  Language: Language;
  LastEditDate: string;
  Type: string;
  Value: string;

  constructor(data?: Partial<Translation>) {
    Object.assign(this, data);
  }
}
